exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-number-input[data-v-bf39b0c6] {\n  align-items: flex-start;\n  display: flex;\n}\n.app-number-input .append-outer[data-v-bf39b0c6],\n.app-number-input .prepend-outer[data-v-bf39b0c6] {\n  margin-top: 16px;\n  color: var(--v-gray-base);\n}\n.app-number-input .prepend-outer[data-v-bf39b0c6] {\n  margin-right: 8px;\n}\n.app-number-input .append-outer[data-v-bf39b0c6] {\n  margin-left: 8px;\n}\n.app-number-input .v-money[data-v-bf39b0c6]:disabled {\n  color: rgba(0,0,0,0.38) !important;\n}\n.app-number-input .v-label[data-v-bf39b0c6] {\n  left: 0px;\n  right: auto;\n  position: absolute;\n}\n", ""]);

// exports
